<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Final Score: </p>
        <p><strong>{{ captureTask.achievedMarks + " / " + captureTask.totalMarks }}</strong></p>
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Assessor Comment:</label>
        <vs-textarea readOnly v-model="captureTask.assessorComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Evaluator Comment:</label>
        <vs-textarea readOnly v-model="captureTask.evaluatorComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Moderator Comment:</label>
        <vs-textarea v-model="captureTask.moderatorComment" />
      </div>
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Predefined Comments:</label>
        <v-select placeholder="Search / Select Predefined Comment" :options="predefinedComments" v-model="predCommentDropdown" @search:blur="addComment"></v-select>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      captureTask: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        predCommentDropdown: 0
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    methods: {
      addComment() {
        var self = this;
        if(self.predCommentDropdown){
          if(self.captureTask.moderatorComment == null) {
            self.captureTask.moderatorComment = "";
          }
          self.captureTask.moderatorComment += self.predCommentDropdown.label + " ";
        }
      }
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">

</style>
